<template>
  <div class="baojia">
    <img class="bg" src="../assets/baojia/bg.png"/>
    <div class="box">
      <!-- <a href="/images/myw3schoolimage.jpg" download="w3logo">555</a> -->
      <div class="text" style="margin-top: 3rem">查看单据明细</div>
      <div class="text" style="margin-top: .2rem">请登入车店无忧-订货商城-我的订单中查看</div>
      <img class="logo" style="margin-top: 1rem" src="../assets/baojia/code.png" />
      <div class="text" style="margin-top: .02rem">长按保存图片扫码下载车店无忧</div>
      <div class="text">
        	或 <span class="copy" @click="handleCopy" data-clipboard-action="copy" 
          data-clipboard-text="https://download.51autoshop.com/app.html">复制下载地址</span>
      </div>
      <!-- <img class="ios" style="margin-top: 1rem" src="../assets/baojia/ios.png" /> -->
      <!-- <img class="ios" src="../assets/baojia/az.png" /> -->
    </div>
    <img class="footer" src="../assets/baojia/d.png"/>
    <div class="black" @click="handleBlackPage">返回</div>
  </div>
</template>

<script>

import clipboard from "clipboard";
import { Toast } from 'vant';

export default {
  mounted() {
      this.$emit("footer", false);
  },
  methods: {
    // 复制
    handleCopy() {
      let clipboardUrl = new clipboard(".copy");
      clipboardUrl.on("success", function() {
        Toast("复制成功，请在浏览器粘贴打开");
      });
    },
    handleBlackPage() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.copy {
  
  background: rgba(79, 174, 84, 1);
  border-radius: 0.1rem;
  font-size: 0.22rem;
  color: rgba(255, 255, 255, 1);
  display: inline-block;
  text-align: center;
  padding: 5px;
}
.baojia {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  .bg {
    position: absolute;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
  }
  .box {
    position: absolute;
    width: 100%;
    height: auto;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    text-align: center;
  }
  .text {
    color: #fff;
    font-size: .26rem;
    letter-spacing: 1px;
    text-align: center;
  }
  .logo {
    width: 3rem;
    height: 3rem;
  }
  .ios {
    width: 6.19rem;
    height: 1.01rem;
  }
  .footer {
    width: 3.36rem;
    height: 1.69rem;
    position: absolute;
    bottom: 1rem;
    left: 50%;
    z-index: 2;
    margin-left: -1.68rem;
  }
  .black {
    position: fixed;
    left: 0px;
    bottom: 0px;
    height:.8rem;
    width: 100%;
    background:rgba(79,174,84,1);
    color: #fff;
    text-align: center;
    line-height: .8rem;
    font-size: .24rem;
    letter-spacing: 1px;
    z-index: 3;
  }
}
/* 判断iphoneX 将 fix-ios-footer 的 padding-bottom 填充到最底部 */
@supports (bottom: env(safe-area-inset-bottom)) {
    .footer {
        bottom: calc( env(safe-area-inset-bottom) + .8rem) !important;
    }
    .black{
        bottom: calc( env(safe-area-inset-bottom) + 0px ) !important;
    }
    .black::after{
        position:fixed;
        content: " ";
        background: #fff;
        height: calc( env(safe-area-inset-bottom) );
        bottom: 0px ;
        right: 0px;
        left: 0px;
    }
}


</style>


